import { useCallback } from 'react';

export default function useGridSortState({
  serverSideSorting,
  setSortModel,
  settingsSortModel,
  tableKey,
  updateSettings,
}) {
  const sortModel =
    Array.isArray(settingsSortModel) && settingsSortModel.length > 0
      ? settingsSortModel
      : undefined;

  const handleSortModelChange = useCallback(
    (newSortModel) => {
      if (serverSideSorting) {
        setSortModel?.(newSortModel);
      }
      if (!tableKey) return;
      updateSettings({ sortModel: newSortModel });
    },
    [serverSideSorting, setSortModel, tableKey, updateSettings]
  );

  return {
    sortModel,
    handleSortModelChange,
  };
}
